import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { apiCall } from '../api/client';
import { useAuth } from '../contexts/AuthContext';

export default function HomeownerDashboard() {
  const { user } = useAuth();
  const { data: requests, isLoading } = useQuery({
    queryKey: ['my-requests'],
    queryFn: () => apiCall<any[]>('/requests'),
  });

  return (
    <div className="page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--space-xl)' }}>
        <h1 style={{ fontSize: '1.6rem', fontWeight: 700 }}>My Work Orders</h1>
        <Link to="/send-a-doe">
          <button className="btn-primary">🦌 Send a Doe</button>
        </Link>
      </div>

      {isLoading ? (
        <div style={{ textAlign: 'center', padding: 48 }}><div className="doe-spinner" style={{ margin: '0 auto' }} /></div>
      ) : !requests?.data?.length ? (
        <div className="card" style={{ textAlign: 'center', padding: 48 }}>
          <p style={{ fontSize: '3rem', marginBottom: 16 }}>🦌</p>
          <h2 style={{ fontWeight: 600, marginBottom: 8 }}>No work orders yet</h2>
          <p style={{ opacity: 0.7, marginBottom: 24 }}>Tap "Send a Doe" to get started!</p>
          <Link to="/send-a-doe"><button className="btn-primary">Send a Doe</button></Link>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: 'var(--space-md)' }}>
          {requests.data.map((req: any) => (
            <Link key={req.id} to={`/requests/${req.id}`} style={{ textDecoration: 'none' }}>
              <div className="card" style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-md)' }}>
                <div style={{ fontSize: '2rem' }}>{req.trade_icon || '🔨'}</div>
                <div style={{ flex: 1 }}>
                  <h3 style={{ fontWeight: 600 }}>{req.trade_name || 'Service Request'}</h3>
                  <p style={{ fontSize: '0.85rem', opacity: 0.7 }}>{req.problem_label || req.description || 'No details'}</p>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <span className={`badge badge-${req.status === 'completed' ? 'online' : req.status === 'cancelled' ? 'offline' : 'pending'}`}>
                    {req.status}
                  </span>
                  <p style={{ fontSize: '0.75rem', opacity: 0.5, marginTop: 4 }}>
                    {new Date(req.created_at * 1000).toLocaleDateString()}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
